type PropertyLimits = {
	maxPagesCount: number;
};

// todo: change to async + get data from server
export const getLimits = (): PropertyLimits => {
	return {
		maxPagesCount: 5000
	};
};
